import { CnFormItem } from "../cn-form-item";
import { CnInput } from "../cn-input";
import { CnNumberPicker } from "../cn-number-picker";
import { CnOSSUpload } from "../cn-oss-upload";
import { CnOSSImageUpload } from "../cn-oss-image-upload";
import { CnInputTextArea } from "../cn-input-textarea";
import { CnSelect } from "../cn-select";
import { CnAsyncSelect } from "../cn-async-select";
import { CnDepartmentSelect } from "../cn-department-select";
import { CnEmployeeSelect } from "../cn-employee-select";
import { CnFormGrid } from "../cn-form-grid";
import { CnCard, CnCardSubCard } from "../cn-card";
import { CnSwitch } from "../cn-switch";
import { CnRating } from "../cn-rating";
import { CnRadioGroup } from "../cn-radio-group";
import { CnCascaderSelect } from "../cn-cascader-select";
import { CnSelector } from "../cn-selector";
import { CnFormArrayCard } from "../cn-form-array-card";
import { CnTimePickerPro } from "../cn-time-picker-pro";
import { CnReadOnly } from "../cn-read-only";
import { CnSearch } from "../cn-search";
import { CnCheckbox, CnCheckboxGroup } from "../cn-checkbox-group";
import { CnDatePickerPro, CnWeekPickerPro, CnMonthPickerPro, CnYearPickerPro, } from "../cn-date-picker-pro";
import { CnDateRangePickerPro } from "../cn-date-range-picker-pro";
import { CnAgreement } from "../cn-agreement";
import { CnResult } from "../cn-result";
import { CnStep, CnStepItem } from "../cn-step";
export var componentMap = {
    CnFormItem: CnFormItem,
    CnFilterItem: CnFormItem,
    CnFilterProItem: CnFormItem,
    CnSelect: CnSelect,
    CnAsyncSelect: CnAsyncSelect,
    CnDepartmentSelect: CnDepartmentSelect,
    CnEmployeeSelect: CnEmployeeSelect,
    CnInput: CnInput,
    CnNumberPicker: CnNumberPicker,
    CnOSSUpload: CnOSSUpload,
    CnOSSImageUpload: CnOSSImageUpload,
    CnInputTextArea: CnInputTextArea,
    CnFormGrid: CnFormGrid,
    CnCard: CnCard,
    CnCardSubCard: CnCardSubCard,
    CnSwitch: CnSwitch,
    CnRating: CnRating,
    CnRadioGroup: CnRadioGroup,
    CnReadOnly: CnReadOnly,
    CnCascaderSelect: CnCascaderSelect,
    CnSelector: CnSelector,
    CnFormArrayCard: CnFormArrayCard,
    CnTimePickerPro: CnTimePickerPro,
    CnDatePickerPro: CnDatePickerPro,
    CnCheckbox: CnCheckbox,
    CnCheckboxGroup: CnCheckboxGroup,
    CnWeekPickerPro: CnWeekPickerPro,
    CnMonthPickerPro: CnMonthPickerPro,
    CnYearPickerPro: CnYearPickerPro,
    CnDateRangePickerPro: CnDateRangePickerPro,
    CnRangeDatePickerPro: CnDateRangePickerPro,
    CnAgreement: CnAgreement,
    CnResult: CnResult,
    CnStep: CnStep,
    CnStepItem: CnStepItem,
    CnSearch: CnSearch,
};
